import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  viewBox: "0 0 17 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 3a.25.25 0 0 0-.25.25v9.36l3.106-2.683a1.75 1.75 0 0 1 2.288 0l3.106 2.684V3.25A.25.25 0 0 0 12.5 3zm-1.75.25c0-.966.784-1.75 1.75-1.75h8c.966 0 1.75.784 1.75 1.75v11a.75.75 0 0 1-1.24.568l-4.347-3.756a.25.25 0 0 0-.326 0L3.99 14.818a.75.75 0 0 1-1.24-.568z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }